export enum Frequence {
  'diaria' = 0,
  'semanal' = 1,
  'mensual' = 2,
  'bimestral' = 3,
  'trimestral' = 4,
  'semestral' = 5,
  'anual' = 6,
}
